import FrenchPage from '../components/lifecycle/FrenchPage';
import BookingsHeadFR from '../components/bookings/BookingsHeadFR';
import Bookings from './Bookings'

export default function BookingsFR() {
  return (
    <>
      <FrenchPage />
      <BookingsHeadFR />
      <Bookings />
    </>
  );
}